import context from '../context';
import getEmptyProjectedSale from './getEmptyProjectedSale';
import { PROJECTED_SALE_TYPES } from '../constants';

export default function getProjectedSales(revenue, locationIds = [], relevantDays = []) {
  if (!context.laborCostSettings) {
    return;
  }

  let relevantLocationIds = locationIds.length
    ? locationIds
    : Object.keys(context.personasDict).reduce(_locationIdsReducer, []);
  relevantLocationIds = relevantLocationIds.map((id) => String(id));

  const projectedSales = revenue.reduce((reduced, { location, sales }) => {
    if (relevantLocationIds.includes(String(location.id))) {
      return {
        ...reduced,
        [location.id]: getSalesGroupedByDate(sales, location.id, relevantDays),
      };
    }

    return reduced;
  }, {});

  return {
    totalProjectedSales: getProjectedSalesSummary(projectedSales),
    totalByLocation: getProjectedSalesByLocation(projectedSales),
    sales: _fillWithDummies(projectedSales, relevantLocationIds, relevantDays),
  };
}

function _locationIdsReducer(locations, id) {
  return context.personasDict[id].type === 'location' ? [...locations, id] : locations;
}

function _fillWithDummies(projectedSales, relevantLocationIds, relevantDays) {
  relevantLocationIds.forEach((id) => {
    if (!(id in projectedSales)) {
      projectedSales[id] = {};
    }

    relevantDays.forEach((day) => {
      if (!(day in projectedSales[id])) {
        projectedSales[id][day] = {};
      }
    });
  });

  return projectedSales;
}

function getSalesGroupedByDate(sales, locationId, relevantDays) {
  return sales.reduce((grouped, sale) => {
    if (!relevantDays.includes(sale.date)) {
      return grouped;
    }

    const overriddenSale =
      sale.type === PROJECTED_SALE_TYPES.override ? sale : getSaleOverride(sale, locationId);

    return {
      ...grouped,
      [sale.date]: overriddenSale,
    };
  }, {});
}

function getSaleOverride(sale, locationId) {
  return {
    ...getEmptyProjectedSale(PROJECTED_SALE_TYPES.override, locationId, sale.date),
    default: sale.amount,
  };
}

function getProjectedSalesSummary(sales) {
  return Object.keys(sales).reduce((sum, locationId) => sum + sumUpSales(sales[locationId]), 0);
}

function getProjectedSalesByLocation(sales) {
  return Object.entries(sales).reduce((agg, [locationId, locationSales]) => {
    agg[locationId] = sumUpSales(locationSales);
    return agg;
  }, {});
}

function sumUpSales(salesByDate) {
  return Object.keys(salesByDate).reduce((sum, date) => {
    const sale = salesByDate[date];
    return sum + (Number(sale.amount) || Number(sale.default) || 0);
  }, 0);
}
